module.exports = __webpack_public_path__ + "static/digital_strategy_approach-e5f53406364e42af24e10a925c347a20.jpg";